import React from "react";


function Footer() {

    return (
        <footer className="container-fluid">
            <div className="container py-4">
                <p className="text-light">This project was created for a Full Stack Web Development Bootcamp. Copyright © 2021 RojoRevolution. All Rights Reserved.</p>
            </div>
        </footer>
    )

}

export default Footer;